import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import Link from 'flarum/common/components/Link';

export default class MobileRegisterPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    this.phone = Stream('');
    this.code = Stream('');
    this.countryCode = Stream('+86');
    this.sendCodeDisabled=false;
    this.countdown = 0;
    this.loading = false;
    this.phoneChecked = false;
    this.phoneExists = false;
    this.errorMessage = Stream('');
    this.successMessage = Stream('');
    this.timer = null;
    this.agreeTerms = Stream(false);
  }

  // 获取国家代码的辅助方法，确保始终有值
  getCountryCode() {
    if (!this.countryCode) {
      return '+86';
    }
    const code = this.countryCode();
    return code || '+86';
  }
  oncreate() {
    // this.startCountdown();
  }
  // 组件销毁时清理倒计时
  onremove() {
    this.stopCountdown();
  }

  view() {
    return (
      <div className="MobileRegisterPage">
        <div className="MobileRegisterPage-content">
        <h1 className="MobileRegisterPage-title">{app.translator.trans('tf-sso.forum.login.title')}</h1>
            <p className="MobileRegisterPage-subtitle">{app.translator.trans('tf-sso.forum.login.subtitle')}</p>

          <div className="MobileRegisterPage-card">
            
            {/* 错误消息显示 */}
            {this.errorMessage() && (
              <div className="Alert Alert--error">
                {this.errorMessage()}
              </div>
            )}

            {/* 成功消息显示 */}
            {this.successMessage() && (
              <div className="Alert Alert--success">
                {this.successMessage()}
              </div>
            )}

            {/* 手机号输入 */}
            <div className="Form-group">
              <div className="PhoneInput">
                <div className="PhoneInput-icon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 1H5C3.89543 1 3 1.89543 3 3V17C3 18.1046 3.89543 19 5 19H15C16.1046 19 17 18.1046 17 17V3C17 1.89543 16.1046 1 15 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 15H10.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="CountryCodeSelector">
                  <span className="CountryCodeDisplay">{this.getCountryCode()}</span>
                  <select
                    className="CountryCodeSelect"
                    value={this.getCountryCode()}
                    onchange={(e) => {
                      const selectedValue = e.target.value;
                      if (this.countryCode) {
                        this.countryCode(selectedValue);
                      }
                      m.redraw();
                    }}
                  >
                    <option value="+93">Afghanistan (+93)</option>
                    <option value="+355">Albania (+355)</option>
                    <option value="+213">Algeria (+213)</option>
                    <option value="+1">United States (+1)</option>
                    <option value="+376">Andorra (+376)</option>
                    <option value="+244">Angola (+244)</option>
                    <option value="+54">Argentina (+54)</option>
                    <option value="+374">Armenia (+374)</option>
                    <option value="+61">Australia (+61)</option>
                    <option value="+43">Austria (+43)</option>
                    <option value="+994">Azerbaijan (+994)</option>
                    <option value="+973">Bahrain (+973)</option>
                    <option value="+880">Bangladesh (+880)</option>
                    <option value="+375">Belarus (+375)</option>
                    <option value="+32">Belgium (+32)</option>
                    <option value="+501">Belize (+501)</option>
                    <option value="+229">Benin (+229)</option>
                    <option value="+591">Bolivia (+591)</option>
                    <option value="+387">Bosnia (+387)</option>
                    <option value="+55">Brazil (+55)</option>
                    <option value="+359">Bulgaria (+359)</option>
                    <option value="+855">Cambodia (+855)</option>
                    <option value="+237">Cameroon (+237)</option>
                    <option value="+1">Canada (+1)</option>
                    <option value="+56">Chile (+56)</option>
                    <option value="+86">China (+86)</option>
                    <option value="+57">Colombia (+57)</option>
                    <option value="+385">Croatia (+385)</option>
                    <option value="+53">Cuba (+53)</option>
                    <option value="+357">Cyprus (+357)</option>
                    <option value="+420">Czech Republic (+420)</option>
                    <option value="+45">Denmark (+45)</option>
                    <option value="+20">Egypt (+20)</option>
                    <option value="+372">Estonia (+372)</option>
                    <option value="+251">Ethiopia (+251)</option>
                    <option value="+358">Finland (+358)</option>
                    <option value="+33">France (+33)</option>
                    <option value="+995">Georgia (+995)</option>
                    <option value="+49">Germany (+49)</option>
                    <option value="+233">Ghana (+233)</option>
                    <option value="+30">Greece (+30)</option>
                    <option value="+852">Hong Kong (+852)</option>
                    <option value="+36">Hungary (+36)</option>
                    <option value="+354">Iceland (+354)</option>
                    <option value="+91">India (+91)</option>
                    <option value="+62">Indonesia (+62)</option>
                    <option value="+98">Iran (+98)</option>
                    <option value="+964">Iraq (+964)</option>
                    <option value="+353">Ireland (+353)</option>
                    <option value="+972">Israel (+972)</option>
                    <option value="+39">Italy (+39)</option>
                    <option value="+81">Japan (+81)</option>
                    <option value="+962">Jordan (+962)</option>
                    <option value="+7">Kazakhstan (+7)</option>
                    <option value="+254">Kenya (+254)</option>
                    <option value="+965">Kuwait (+965)</option>
                    <option value="+996">Kyrgyzstan (+996)</option>
                    <option value="+856">Laos (+856)</option>
                    <option value="+371">Latvia (+371)</option>
                    <option value="+961">Lebanon (+961)</option>
                    <option value="+370">Lithuania (+370)</option>
                    <option value="+352">Luxembourg (+352)</option>
                    <option value="+853">Macau (+853)</option>
                    <option value="+60">Malaysia (+60)</option>
                    <option value="+52">Mexico (+52)</option>
                    <option value="+976">Mongolia (+976)</option>
                    <option value="+212">Morocco (+212)</option>
                    <option value="+95">Myanmar (+95)</option>
                    <option value="+977">Nepal (+977)</option>
                    <option value="+31">Netherlands (+31)</option>
                    <option value="+64">New Zealand (+64)</option>
                    <option value="+47">Norway (+47)</option>
                    <option value="+968">Oman (+968)</option>
                    <option value="+92">Pakistan (+92)</option>
                    <option value="+51">Peru (+51)</option>
                    <option value="+63">Philippines (+63)</option>
                    <option value="+48">Poland (+48)</option>
                    <option value="+351">Portugal (+351)</option>
                    <option value="+974">Qatar (+974)</option>
                    <option value="+40">Romania (+40)</option>
                    <option value="+7">Russia (+7)</option>
                    <option value="+966">Saudi Arabia (+966)</option>
                    <option value="+65">Singapore (+65)</option>
                    <option value="+421">Slovakia (+421)</option>
                    <option value="+386">Slovenia (+386)</option>
                    <option value="+27">South Africa (+27)</option>
                    <option value="+82">South Korea (+82)</option>
                    <option value="+34">Spain (+34)</option>
                    <option value="+94">Sri Lanka (+94)</option>
                    <option value="+46">Sweden (+46)</option>
                    <option value="+41">Switzerland (+41)</option>
                    <option value="+886">Taiwan (+886)</option>
                    <option value="+992">Tajikistan (+992)</option>
                    <option value="+66">Thailand (+66)</option>
                    <option value="+90">Turkey (+90)</option>
                    <option value="+993">Turkmenistan (+993)</option>
                    <option value="+380">Ukraine (+380)</option>
                    <option value="+971">UAE (+971)</option>
                    <option value="+44">United Kingdom (+44)</option>
                    <option value="+598">Uruguay (+598)</option>
                    <option value="+998">Uzbekistan (+998)</option>
                    <option value="+58">Venezuela (+58)</option>
                    <option value="+84">Vietnam (+84)</option>
                    <option value="+967">Yemen (+967)</option>
                  </select>
                </div>
                <input
                  type="tel"
                  className="FormControl PhoneInput-field"
                  placeholder={app.translator.trans('tf-sso.forum.login.phone_number')}
                  bidi={this.phone}
                  disabled={this.countdown > 0}
                  onblur={this.checkPhone.bind(this)}
                />
              </div>
            </div>

            {/* 验证码输入 */}
            <div className="Form-group">
              <div className="VerificationCodeInput">
                <div className="VerificationCodeIcon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="8" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6 8V5C6 2.79086 7.79086 1 10 1C12.2091 1 14 2.79086 14 5V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <input
                  type="text"
                  className="FormControl VerificationCodeField"
                  placeholder={app.translator.trans('tf-sso.forum.login.verification_code')}
                  bidi={this.code}
                />
                <Button
                  className="Button Button--send"
                  onclick={this.sendCode.bind(this)}
                  disabled={this.sendCodeDisabled === true || this.countdown > 0}
                >
                  {this.countdown > 0 ? `${this.countdown}s` : app.translator.trans('tf-sso.forum.login.send')}
                </Button>
              </div>
            </div>

            {/* 登录按钮 */}
            <div className="Form-group">
              <Button
                className="Button Button--login Button--block"
                onclick={this.register.bind(this)}
                loading={this.loading}
              >
                {app.translator.trans('tf-sso.forum.login.login_button')}
              </Button>
            </div>

            {/* 条款同意复选框 */}
            <div className="MobileRegisterPage-terms">
              <label className="MobileRegisterPage-terms-label">
                <input
                  type="checkbox"
                  className="MobileRegisterPage-terms-checkbox"
                  checked={this.agreeTerms()}
                  onchange={(e) => {
                    this.agreeTerms(e.target.checked);
                    m.redraw();
                  }}
                />
                <span className="MobileRegisterPage-terms-text">
                  {app.translator.trans('tf-sso.forum.login.terms_text')}{' '}
                  <Link href={app.forum.attribute('baseUrl') + '/terms'} className="MobileRegisterPage-terms-link">
                    {app.translator.trans('tf-sso.forum.login.terms_link')}
                  </Link>
                  {' '}{app.translator.trans('tf-sso.forum.login.and')}{' '}
                  <Link href={app.forum.attribute('baseUrl') + '/privacy'} className="MobileRegisterPage-terms-link">
                    {app.translator.trans('tf-sso.forum.login.privacy_link')}
                  </Link>
                  .
                </span>
              </label>
            </div>

            {/* 底部说明文字 */}
            {/* <div className="MobileRegisterPage-disclaimer">
              Auto login after verification of unregistered mobile phone by registering
            </div> */}
          </div>
        </div>
      </div>
    );
  }

  // 验证手机号是否已注册
  async checkPhone() {
    const phone = this.phone().trim();
    if (!phone || !this.isValidPhone(phone)) {
      this.phoneChecked = false;
      return;
    }

    const countryCode = this.getCountryCode();

    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/sso/check-user',
        body: {
          phone: phone,
          country_code: countryCode
        }
      });

      this.phoneExists = response.data.attributes.rawResponse.is_exist || false;
      this.phoneChecked = true;
      this.errorMessage('');
    } catch (error) {
      console.error('检查手机号失败:', error);
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_check_phone_failed'));
    }
  }

  // 发送验证码
  async sendCode() {
    const phone = this.phone().trim();
    
    if (!phone) {
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_phone_required'));
      return;
    }

    if (!this.isValidPhone(phone)) {
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_phone_invalid'));
      return;
    }

    const countryCode = this.getCountryCode();

    try {
      this.sendCodeDisabled = true;
      this.startCountdown();
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/sso/send-code',
        body: {
          phone: phone,
          country_code: countryCode
        }
      });

      
    } catch (error) {
      console.error('发送验证码失败:', error);
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_send_code_failed'));
    }
  }

  // 注册/登录
  async register() {
    const phone = this.phone().trim();
    const code = this.code().trim();

    // 基本验证
    if (!phone) {
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_phone_required'));
      return;
    }

    if (!this.isValidPhone(phone)) {
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_phone_invalid'));
      return;
    }

    if (!code) {
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_code_required'));
      return;
    }

    if (!this.agreeTerms()) {
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_terms_required'));
      return;
    }

    // if (!this.phoneExists && !username) {
    //   this.errorMessage('请输入用户名');
    //   return;
    // }

    // if (!this.phoneExists && !password) {
    //   this.errorMessage('请输入密码');
    //   return;
    // }

    this.loading = true;
    this.errorMessage('');

    const countryCode = this.getCountryCode();

    try {
      const requestBody = {
        phone: phone,
        sms_code: code,
        country_code: countryCode
      };

      // 添加可选参数
      // if (username) {
      //   requestBody.full_name = username;
      // }

      // 获取用户IP地址（如果可用）
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        requestBody.user_ip_address = ipData.ip;
      } catch (ipError) {
        console.warn('无法获取IP地址:', ipError);
      }

      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/sso/account-login',
        body: requestBody
      });

      // 处理成功响应
      if (response.data) {
        // 从响应中提取权限字段并存储到 localStorage
        const attributes = response.data.attributes || {};
        const nickNameCanChanged = attributes.nick_name_can_changed !== undefined ? attributes.nick_name_can_changed : true;
        const headimgCanChanged = attributes.headimg_can_changed !== undefined ? attributes.headimg_can_changed : true;
        
        // 存储到 localStorage
        try {
          localStorage.setItem('nick_name_can_changed', JSON.stringify(nickNameCanChanged));
          localStorage.setItem('headimg_can_changed', JSON.stringify(headimgCanChanged));
        } catch (e) {
          console.warn('无法保存权限信息到 localStorage:', e);
        }
        
        // 清除错误消息，显示成功消息
        this.errorMessage('');
        this.successMessage(app.translator.trans('tf-sso.forum.login.success_login'));
        
        // 延迟跳转，让用户看到成功消息
        setTimeout(() => {
          // 优先跳转到登录前页面
          let redirectUrl = null;
          try {
            const savedUrl = sessionStorage.getItem('tf-sso.loginReturnUrl');
            if (savedUrl) {
              sessionStorage.removeItem('tf-sso.loginReturnUrl');
              // 验证：同源且非登录页
              try {
                const url = new URL(savedUrl);
                const isSameOrigin = url.origin === window.location.origin;
                const isLoginPage = url.pathname.includes('/mobile-register') || url.pathname.includes('/admlogin');
                if (isSameOrigin && !isLoginPage) {
                  redirectUrl = savedUrl;
                }
              } catch (e) {
                console.warn('[tf/sso] 登录返回 URL 无效:', e);
              }
            }
          } catch (e) {
            console.warn('[tf/sso] 读取登录前页面失败:', e);
          }
          window.location.href = redirectUrl || (window.location.origin + window.location.pathname.split('/').slice(0, -1).join('/') + '/');
        }, 1000);
      } else {
        this.errorMessage(response.message || app.translator.trans('tf-sso.forum.login.error_operation_failed'));
      }
    } catch (error) {
      console.error('登录失败:', error);
      this.errorMessage(app.translator.trans('tf-sso.forum.login.error_code_invalid'));
    } finally {
      this.loading = false;
    }
  }

  // 验证手机号格式
  isValidPhone(phone) {
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  }

  // 开始倒计时 - 使用setInterval
  startCountdown() {
    // 先停止之前的倒计时
    this.stopCountdown();
    
    this.countdown = 60;
    this.timer = setInterval(() => {
      this.countdown--;
      m.redraw(); // 触发视图更新
      
      if (this.countdown <= 0) {
        this.stopCountdown();
        this.sendCodeDisabled = false;
      }
    }, 1000);
  }
  
  // 停止倒计时
  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;

    }
  }
}
